import { config } from './config';

const CONSENT_KEY = 'coopcore_marketing_analytics_consent';

declare global {
  interface Window { dataLayer?: unknown[]; gtag?: (...args: unknown[]) => void; }
}

export type AnalyticsConsent = 'accepted' | 'declined' | null;

export function getAnalyticsConsent(): AnalyticsConsent {
  const value = localStorage.getItem(CONSENT_KEY);
  return value === 'accepted' || value === 'declined' ? value : null;
}

export function setAnalyticsConsent(value: Exclude<AnalyticsConsent, null>) {
  localStorage.setItem(CONSENT_KEY, value);
  if (value === 'accepted') initialiseAnalytics();
}

export function initialiseAnalytics() {
  if (!config.analyticsId || getAnalyticsConsent() !== 'accepted' || document.getElementById('coopcore-analytics')) return;
  const script = document.createElement('script');
  script.id = 'coopcore-analytics';
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(config.analyticsId)}`;
  document.head.appendChild(script);
  window.dataLayer = window.dataLayer || [];
  window.gtag = (...args: unknown[]) => window.dataLayer?.push(args);
  window.gtag('js', new Date());
  window.gtag('config', config.analyticsId, { anonymize_ip: true });
}

export function track(name: string, parameters: Record<string, string | number | boolean> = {}) {
  if (getAnalyticsConsent() === 'accepted' && window.gtag) window.gtag('event', name, parameters);
}
